import { TherapistCombobox } from "@/components/ui/therapist-combobox";
import { Button } from "@/components/ui/button";
import type { PlaceholderSubject } from "@/lib/documents/placeholders";

interface PreviewBarProps {
  subject: PlaceholderSubject | null;
  subjectId: string;
  onSubjectIdChange: (id: string) => void;
  onDownload: () => void;
  isPending: boolean;
}

export function PreviewBar({
  subject,
  subjectId,
  onSubjectIdChange,
  onDownload,
  isPending,
}: PreviewBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {subject === "terapeut" ? (
        <TherapistCombobox
          value={subjectId || null}
          onChange={(id) => onSubjectIdChange(id ?? "")}
          placeholder="Izaberi terapeuta"
          className="w-64"
        />
      ) : null}
      {subject && subject !== "terapeut" ? (
        <span className="text-sm text-muted-foreground">
          Polja za ovaj tip dokumenta ostaju prazna dok se ne izabere strana.
        </span>
      ) : null}
      <Button variant="outline" onClick={onDownload} disabled={isPending}>
        Preuzmi PDF
      </Button>
    </div>
  );
}
